<script setup lang="ts">
  import type { Benefit } from '@/models/benefit';
  import { convertMultilineContent } from '@/utils/content-utils';
  import type { PropType } from 'vue';
  import { computed } from 'vue';
  import BenefitsMobile from '@/components/benefits/BenefitsMobile.vue';
  import BenefitsDesktop from '@/components/benefits/BenefitsDesktop.vue';

  const props = defineProps({
    benefits: {
      type: Array as PropType<Benefit[]>,
      required: true
    },
    heading: {
      type: String,
      default: ''
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  });

  const mappedHeading = computed(() => {
    return convertMultilineContent(props.heading)!;
  });
</script>

<template>
  <section class="benefits-section">
    <div class="container">
      <BenefitsMobile
        v-if="isMobile"
        :heading="mappedHeading"
        :benefits="benefits" />
      <BenefitsDesktop
        v-else
        :heading="mappedHeading"
        :benefits="benefits" />
    </div>
  </section>
</template>
